define('components/ForceDesktop',[
    "jquery",
    "logging",
    "utilities"
], function($, logging, utilities) {
    var _ModuleName = "Force Desktop";

    function ForceDesktop(scope) {
        "use strict";

        var $link = $(scope);

        $link.click(function( evt ) {
            evt.stopPropagation && evt.stopPropagation();
            evt.preventDefault && evt.preventDefault();

            ;

            utilities.setCookie('force-desktop', true);
            location.reload(true);
        });

        ;
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            // Do not initialize the module if we are on a mobile device
            if (utilities.IsMobile() === false) {
                ;
                return null;
            }

            ;
            return new ForceDesktop(args.scope);
        }
    }
});
